import { Card } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Check } from "lucide-react";
import { PRICING } from "../data/mock";
import { useToast } from "../hooks/use-toast";

export default function Pricing() {
  const { toast } = useToast();
  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
      <div className="max-w-3xl mx-auto text-center">
        <Badge className="bg-emerald-50 text-emerald-800 hover:bg-emerald-50 border-emerald-200 mb-3">Pricing</Badge>
        <h1 className="text-4xl lg:text-5xl font-extrabold text-stone-900 tracking-tight">Simple plans for every crew size.</h1>
        <p className="mt-4 text-lg text-stone-600">Start free. Upgrade when your field operations grow.</p>
      </div>

      <div className="mt-12 grid md:grid-cols-3 gap-5">
        {PRICING.map((p) => (
          <Card
            key={p.id}
            className={`p-7 border bg-white relative flex flex-col ${
              p.highlight ? "border-emerald-600 shadow-lg ring-1 ring-emerald-600/20" : "border-stone-200"
            }`}
          >
            {p.highlight && (
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-emerald-700 text-white text-[11px] font-semibold rounded-full tracking-wide uppercase">
                Most popular
              </div>
            )}
            <h3 className="text-xl font-bold text-stone-900">{p.name}</h3>
            <p className="mt-1.5 text-sm text-stone-600">{p.blurb}</p>
            <div className="mt-5 flex items-baseline gap-1.5">
              {p.price === null ? (
                <span className="text-4xl font-extrabold text-stone-900">Custom</span>
              ) : (
                <>
                  <span className="text-4xl font-extrabold text-stone-900">${p.price}</span>
                  <span className="text-stone-500 text-sm">/ {p.period}</span>
                </>
              )}
            </div>
            {p.price !== null && p.price > 0 && (
              <div className="text-xs text-stone-500">billed monthly</div>
            )}
            <ul className="mt-6 space-y-2.5 flex-1">
              {p.features.map((f, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-stone-700">
                  <Check className="h-4 w-4 text-emerald-700 mt-0.5 shrink-0" /> {f}
                </li>
              ))}
            </ul>
            <Button
              onClick={() => toast({ title: `${p.cta}`, description: `Selected the ${p.name} plan (demo).` })}
              className={`mt-7 h-11 ${
                p.highlight
                  ? "bg-emerald-700 hover:bg-emerald-800 text-white"
                  : "bg-stone-900 hover:bg-stone-800 text-white"
              }`}
            >
              {p.cta}
            </Button>
          </Card>
        ))}
      </div>

      <div className="mt-14 text-center text-sm text-stone-500">
        All plans include offline maps, GPS positioning and basic measure tools. Cancel anytime.
      </div>
    </div>
  );
}
